var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "main_center clearfix",
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c("div", { staticClass: "top-content" }, [
            _c(
              "div",
              { staticClass: "left-navbar" },
              [
                _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.backBtn } },
                  [_vm._v("返回")]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-right": "10px" },
                    attrs: { type: "primary", size: "small", plain: "" },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v("保存")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "right-content" },
            [
              _c(
                "el-card",
                { staticClass: "box-card", style: { height: _vm.cardHight } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [_c("span", [_vm._v("第三方对接系统配置信息")])]
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "系统名称：",
                                prop: "systemName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "100",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.systemName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "systemName", $$v)
                                  },
                                  expression: "form.systemName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "所属单位：", prop: "orgName" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  maxlength: "50",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.orgName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "orgName", $$v)
                                  },
                                  expression: "form.orgName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "接口类型：", prop: "interType" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectInterTypeClick($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.interType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "interType", $$v)
                                    },
                                    expression: "form.interType",
                                  },
                                },
                                _vm._l(
                                  _vm.interTypeNameList,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.name,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "文件获取方式：",
                                prop: "fileDownMod",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  on: {
                                    change: function ($event) {
                                      return _vm.selectFileDownModClick($event)
                                    },
                                  },
                                  model: {
                                    value: _vm.form.fileDownMod,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "fileDownMod", $$v)
                                    },
                                    expression: "form.fileDownMod",
                                  },
                                },
                                _vm._l(
                                  _vm.fileDownModNamelist,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.name,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                label: "所属监管单位：",
                                prop: "tradeId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.form.tradeId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "tradeId", $$v)
                                    },
                                    expression: "form.tradeId",
                                  },
                                },
                                _vm._l(_vm.tradeIdList, function (item, index) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.orgName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { label: "关联应用：", prop: "appId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { filterable: "" },
                                  model: {
                                    value: _vm.form.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "appId", $$v)
                                    },
                                    expression: "form.appId",
                                  },
                                },
                                _vm._l(_vm.appList, function (item, index) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.appName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }